import { render } from "./Pie10Charts.vue?vue&type=template&id=478f9c04&scoped=true"
import script from "./Pie10Charts.vue?vue&type=script&lang=js"
export * from "./Pie10Charts.vue?vue&type=script&lang=js"

import "./Pie10Charts.vue?vue&type=style&index=0&id=478f9c04&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478f9c04"]])

export default __exports__